export default __webpack_public_path__ + "static/media/welcome-image.c8a490da.png";